import { render, staticRenderFns } from "./RoroVisitViewPanel.vue?vue&type=template&id=7b61e4c8"
import script from "./RoroVisitViewPanel.vue?vue&type=script&lang=js"
export * from "./RoroVisitViewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports